import {styled} from "@mui/material";

export const OrderToolPanelContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'end'
}));
